import serviceDetails from "./serviceDetails";
import shopDetails from "./shopDetails";
import posDetails from "./posDetails";

export const solutionMap = { 
  shop: shopDetails,
  service: serviceDetails,
  pos: posDetails,
}
